/* The tool rail: icon + short label, with a tooltip saying what each tool is
   for. On phones it becomes the bottom tab bar (with a Sheet button for the
   right-hand panel). Background removal (coming soon) is reached from Upload
   and Settings, so the rail only holds tools that work today. */

import { useStore, openPanel, type PanelKey } from '../store/store';
import { Icon, type IconName } from '../ui/icons';
import { NewGangsheetButton } from './StartFresh';

const TOOLS: { key: PanelKey; icon: IconName; label: string; tip: string }[] = [
  { key: 'upload', icon: 'upload', label: 'Upload', tip: 'Upload your artwork (PNG, JPG, SVG, PDF…)' },
  { key: 'designs', icon: 'image', label: 'Designs', tip: 'Your designs: sizes and quantities' },
  { key: 'text', icon: 'type', label: 'Add text', tip: 'Add names, numbers or a slogan' },
  { key: 'nest', icon: 'build', label: 'Auto nest', tip: 'Arrange everything to use the least film' },
  { key: 'settings', icon: 'settings', label: 'Settings', tip: 'Units, snapping, rulers and help' }
];

export function Rail() {
  const panel = useStore(s => s.panel);
  const sideOpen = useStore(s => s.sideOpen);
  const designs = useStore(s => s.doc.designs.length);
  const uploading = useStore(s => Object.values(s.uploads).filter(u => u.status === 'queued' || u.status === 'uploading' || u.status === 'processing').length);
  return (
    <nav className="rail" aria-label="Tools">
      {/* a whole new gangsheet (0.3e): first, and set apart from the tools for this one (not on phones,
          where the rail is the bottom tab bar: the top bar has a + instead) */}
      <span className="rail-newwrap no-phone"><NewGangsheetButton variant="rail" /><span className="rail-sep" aria-hidden="true" /></span>
      {TOOLS.map(t => (
        <button key={t.key} type="button" className="rail-btn" aria-label={t.label} aria-pressed={panel === t.key} data-tip={t.tip} data-tip-pos="right" onClick={() => openPanel(t.key)}>
          <span className="rail-ico">
            <Icon name={t.icon} />
            {t.key === 'designs' && designs > 0 && <i className="rail-badge num">{designs}</i>}
            {t.key === 'upload' && uploading > 0 && <i className="rail-badge is-busy num">{uploading}</i>}
          </span>
          <span className="rail-label">{t.label}</span>
        </button>
      ))}
      <button type="button" className="rail-btn only-phone" aria-label="Sheet" aria-pressed={sideOpen} onClick={() => useStore.setState(s => ({ sideOpen: !s.sideOpen, panel: null }))}>
        <span className="rail-ico"><Icon name="layers" /></span>
        <span className="rail-label">Sheet</span>
      </button>
    </nav>
  );
}
